import styled from '@emotion/styled'

const StyledCheckbox = styled.input`
  width: 1.125rem;
  height: 1.125rem;
`

export default StyledCheckbox
